import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * react-router doesn't scroll to an #anchor on navigation by default.
 * Without this, links like "/#faq" land on top of the target page
 * instead of the section they point to.
 */
export function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0 });
      return;
    }
    const id = hash.replace("#", "");
    // Wait a tick so the target page has rendered before we look for the element.
    const timeout = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 0);
    return () => clearTimeout(timeout);
  }, [hash, pathname]);

  return null;
}
